// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import ApiErrorMessage from './backend/ApiErrorMessage'

export default {
  path: '/error',
  name: 'Common',
  childRoutes: [
    { path: '', name: 'Error', component: ApiErrorMessage, isIndex: true },
  ],
};
